import { render } from "./SocialMediaLinks.vue?vue&type=template&id=0a85d057&scoped=true"
import script from "./SocialMediaLinks.vue?vue&type=script&lang=js"
export * from "./SocialMediaLinks.vue?vue&type=script&lang=js"

import "./SocialMediaLinks.vue?vue&type=style&index=0&id=0a85d057&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a85d057"]])

export default __exports__